// extracted by mini-css-extract-plugin
module.exports = {"content":"ExpandableCollege_content__kZ4aD","expanded":"ExpandableCollege_expanded__2DWya","collapsed":"ExpandableCollege_collapsed__tkEGO"};